import React from 'react';

/** Shorthand for preventing React event handlers from propagating up the tree */
const stopPropagation: React.EventHandler<React.SyntheticEvent> = (e) => {
  e.stopPropagation();
};

export default stopPropagation;
